import React, { useEffect } from 'react';
import { api } from 'api';
import { Link } from 'react-router-dom';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { validate, validators } from 'validate-redux-form';
import { renderField, renderSearchSelect, renderSelectCustom, dateInput, renderTextArea } from 'Utils/renderField/renderField';
import { connect } from 'react-redux';

const getPatients = (search) => {
    return api.get("patients", {search}).catch((error) => {})
        .then((data) => {
            if (data){
                const patients = [];
                data.results.forEach(x=>{
                    patients.push({ value: x.id, label: x.first_name + " " + x.last_name, afiliation: x.no_afiliacion })
                })                
                return patients
            }
            else{
                return []
            }
        })
        .catch(e => {
            console.log("No se obtuvieron datos... ", e)
            return []
        })
}

const getProcedures = (search) => {
    return api.get("igss-procedures", {search}).catch((error) => {})
        .then((data) => {
            if (data){
                const procedures = [];
                data.results.forEach(x=>{                    
                    procedures.push({value: x.id, label: x.name + " " + `(${x.code})` })
                })                
                return procedures;
            }
            else{
                return []
            }
        })
        .catch(e => {
            console.log("No se obtuvieron datos... ", e)
            return []
        })
}

const getDoctors = (search) => {
    return api.get("referents", {search}).catch((error) => {})
        .then((data) => {
            if (data){                 
                const persons = [];
                data.results.forEach(x=>{
                    persons.push({value: x.id, label: x.name})
                })
                
                return persons
            }
            else{
                return []
            }
        })
        .catch(e => {
            return []
        })
}

let Form = props => {
    const {
        afiliation,
        setAfiliation,
        getAfiliationData,
        handleSubmit,
        no_formulario,
        dependency,
        dependencyId,
        itemId
    } = props;

    const view = window.location.href.includes("view");
    const editOrView = window.location.href.includes("edit") || window.location.href.includes("view");

    useEffect(() => {
        if (no_formulario) {
            props.dispatch(change('igssForms', 'dependency', dependency));
            props.dispatch(change('igssForms', 'dependencyId', dependencyId));
        }
    }, [no_formulario]);

    return(
        <form onSubmit={handleSubmit} className="py-2 px-5">            
            <div className="px-md-5 d-flex justify-content-around flex-column flex-sm-row align-items-stretch align-items-sm-center">
                <div className="m-2">
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="name" className="m-0">Dependencia que emite</label>
                    </div>
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center" style={{ fontSize: 10, color: 'green' }}>
                        <Field name="dependency" disabled={true} autofocus component={renderTextArea} type="text" className="form-control"/>
                    </div>
                </div>
                <div className="m-2">
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="name" className="m-0">Médico Solicitante</label>
                    </div>
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <Field
                            name="doctor"
                            valueKey="value"
                            labelKey="label"
                            label="name"
                            component={renderSearchSelect}
                            loadOptions={getDoctors} 
                            className="no-border"
                        />
                    </div>
                </div>                
            </div>            
            <div className="px-md-5 d-flex justify-content-around flex-column flex-sm-row align-items-stretch align-items-sm-center">
                <div className="m-2">
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="name" className="m-0">No. Formulario</label>
                    </div>
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <Field name="no" disabled={view} autofocus component={renderField} type="text" className="form-control"/>
                    </div>
                </div>                
                <div className="m-2"> 
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="person" className="">Buscar y seleccionar paciente</label>
                    </div>
                    <div className=" d-flex justify-content-end flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <Field
                            name="patient"
                            valueKey="value"
                            labelKey="label"
                            label="name"
                            //component={renderSearchSelectPatient}
                            component={renderSearchSelect}
                            loadOptions={getPatients} 
                            className="no-border"
                            onChange={(e) => {                                
                                if(e.afiliation){
                                    setAfiliation(e.afiliation)
                                }else{
                                    setAfiliation(null)
                                }                                
                            }}
                        />
                    </div>
                    {afiliation && <span>No. de afiliación <strong>{afiliation}</strong></span>}
                </div>                
            </div>
            <div className="px-md-5 d-flex justify-content-around flex-column flex-sm-row align-items-stretch align-items-sm-center">
                <div className="m-2">
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="person" className="">Procedimiento</label>
                    </div>
                    <div className=" d-flex justify-content-end flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <Field
                            name="procedure"
                            valueKey="value"
                            labelKey="label"
                            label="name"
                            //component={renderSearchSelectPatient}
                            component={renderSearchSelect}
                            loadOptions={getProcedures}
                            className="no-border"
                            onChange={(e) => {                             
                                //detailPatient(e.value);
                            }}
                        />
                    </div>
                </div>                
                <div className="m-2">
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="person" className="">Tipo de compra</label>
                    </div>
                    <div className=" d-flex justify-content-end flex-column flex-sm-row align-items-stretch align-items-sm-center"> 
                        <Field
                            name="typeOfPurchase"
                            labelKey="label"
                            valueKey="value"
                            component={renderSelectCustom}
                            className="form-control text-left"
                            options={[
                                {value: 1, label:'Baja Cuantia'},
                                {value: 2, label:'Contrato'},
                                {value: 3, label:'Compra directa'},
                                {value: 4, label:'Convenio'}
                            ]}
                        />
                    </div>                   
                </div>                           
            </div>
            <div className="px-md-5 d-flex justify-content-around flex-column flex-sm-row align-items-stretch align-items-sm-center">
                <div className="m-2">
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="person" className="">Origen de la solicitud</label>
                    </div>
                    <div className=" d-flex justify-content-end flex-column flex-sm-row align-items-stretch align-items-sm-center"> 
                        <Field
                            name="requestOrigin"
                            labelKey="label"
                            valueKey="value"
                            component={renderSelectCustom}
                            className="form-control text-left"
                            options={[
                                {value: 1, label:'Hospitalización'},
                                {value: 2, label:'Consulta externa'},
                                {value: 3, label:'Emergencia'}
                            ]}
                        />
                    </div>                   
                </div>                 
                <div className="m-2">
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="person" className="">Tipo de paciente</label>
                    </div>
                    <div className=" d-flex justify-content-end flex-column flex-sm-row align-items-stretch align-items-sm-center"> 
                        <Field
                            name="patientType"
                            labelKey="label"
                            valueKey="value"
                            component={renderSelectCustom}
                            className="form-control text-left"
                            options={[
                                {value: 1, label: 'af'},
                                {value: 2, label: 'be'},
                                {value: 3, label: 'bh'},
                                {value: 4, label: 'pi'},
                                {value: 5, label: 'jub'},
                                {value: 6, label: 'je'}
                            ]}
                        />
                    </div>                   
                </div>  
                {/*              
                <div className="m-2">
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="name" className="m-0">Código del tipo de paciente</label>
                    </div>
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <Field name="patientTypeCode" disabled={view} component={renderField} type="text" className="form-control"/>
                    </div>
                </div>                                         
                */}
            </div>
            <div className="px-md-5 d-flex justify-content-around flex-column flex-sm-row align-items-stretch align-items-sm-center">
                <div className="m-2">
                    <div className=" d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="birthdate" className="">Fecha del formulario</label>
                    </div>
                    <div className=" d-flex justify-content-end flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <Field name="formDate" isDisabled={view} component={dateInput} type="text" className="form-control" />
                    </div>
                </div>
                <div className="m-2">
                    <div className=" d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="birthdate" className="">Fecha del procedimiento</label>
                    </div>
                    <div className=" d-flex justify-content-end flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <Field name="procedureDate" isDisabled={view} component={dateInput} type="text" className="form-control" />
                    </div>
                </div>                                
            </div>      
            <div className="row-fluid">
                <div className="d-flex justify-content-center flex-column flex-sm-row align-items-stretch align-items-sm-center">
                    <Link className="btn btn-secondary m-3" to="/igss-forms">{!view ? ("Cancelar") : ("Regresar")}</Link>
                    {!view && (<button type="submit" className="btn btn-primary m-3">Guardar</button>)}
                    {editOrView && itemId &&                                       
                        <Link className="btn btn-primary m-3" to={`/consult-print/igss-form/${itemId}/`}>Imprimir</Link>
                    }
                </div>
            </div>
            <div className="px-md-5 d-flex justify-content-around flex-column flex-sm-row align-items-stretch align-items-sm-center" style={{ visibility: 'hidden'}}>
                <div className="m-2">
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="name" className="m-0">Id dependencia</label>
                    </div>
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <Field name="dependencyId" disabled={true} component={renderField} type="text" className="form-control"/>
                    </div>
                </div>
            </div>            
       </form>
    )
};
 
Form = reduxForm({
    form: 'igssForms',
    validate: data => {
        return validate(data, {
            'no': validators.exists()('Campo Requerido'),
            'patient': validators.exists()('Campo Requerido'),
            'procedure': validators.exists()('Campo Requerido'),
            'typeOfPurchase': validators.exists()('Campo Requerido'),
            'requestOrigin': validators.exists()('Campo Requerido'),
            'patientType': validators.exists()('Campo Requerido'),
            'formDate': validators.exists()('Campo Requerido'),
            'procedureDate': validators.exists()('Campo Requerido')
        })
    }
})(Form);

const selector = formValueSelector('igssForms');

Form = connect(state => {
    const no_formulario = selector(state, "no");
    const dependencies = state.igss_forms.dependencies;
    
    let dependency = '';
    let dependencyId = 0;
    if(no_formulario){
        const partes = no_formulario.split("-");
        if (partes.length < 3) {
            return "";
        }

        const [inicio, medio, fin, postFin] = partes;

        //if (!/^\d+$/.test(inicio) || !/^\d+$/.test(medio) || !/^\d+$/.test(fin) || !/^\d+$/.test(postFin)) {
        if (!/^\d+$/.test(inicio) || !/^\d+$/.test(medio)) {            
            return "";
        }

        const item = dependencies.find(el => el.code === medio);        
        
        dependency = item ? item.description : 'No se reconoce el código';
        dependencyId = item ? item.id : 0;

        if(partes.length > 4){
           dependency = 'Código inválido';
           dependencyId = 0;
        }
    }

    return {
        no_formulario,
        dependency,
        dependencyId
    };

})(Form);

export default Form
